import { render, staticRenderFns } from "./MoreMobileDishes.vue?vue&type=template&id=45f958fe"
import script from "./MoreMobileDishes.vue?vue&type=script&lang=js"
export * from "./MoreMobileDishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports